<script>
export default {
    name: 'PageFooter',
    mounted() {
        if (process.env.NODE_ENV === 'production') {
            document.getElementsByClassName('livechat').forEach((el) => {
                el.addEventListener('click', this.show)
            })
        }
    },
    beforeDestroy() {
        if (process.env.NODE_ENV === 'production') {
            document.getElementsByClassName('livechat').forEach((el) => {
                el.removeEventListener('click', this.show)
            })
        }
    },
    methods: {
        show(e) {
            e.preventDefault()
            e.stopPropagation()
            this.$intercom?.show()
        },
        t(keys = String || Array) {
            if (!keys) return
            if (typeof keys === 'string')
                return this.$i18n.keyExists(keys) && this.$i18n.translate(keys).length
                    ? this.$i18n.translate(keys)
                    : undefined
            keys = keys
                .reduce((p, key) => {
                    if (this.$i18n.keyExists(key) && this.$i18n.translate(keys).length)
                        p.push(this.$i18n.translate(key))
                    return p
                }, [])
                .join(' ')
            return keys.length ? keys : undefined
        },
    },
}
</script>

<template lang="pug">
lazy-component.bg-white.pt-11.pb-7(tag="footer")
    .container-fluid.container-lg
        .row
            .col-12.col-md-6.col-lg-4
                .bg-primary.border-radius-top-right-xl.border-radius-bottom-right-xl.border-radius-top-left-xl.p-8.text-white.font-size-h1.font-weight-bold(v-if="t('footer.col_1.text')") {{ t('footer.col_1.text') }}

            .col-12.col-md-6.col-lg-3
                .py-8
                    label(v-if="t('footer.col_2.title')") {{ t('footer.col_2.title') }}
                    p(v-if="t('footer.col_2.text')" v-html="t('footer.col_2.text')")
                    a.link-gray.link-icon.d-inline-block.mr-4(
                        v-for="index in [1,2,3]"
                        v-if="t([`footer.col_2.link_${index}.link`, `footer.col_2.link_${index}.icon`])"
                        :class="t(`footer.col_2.link_${index}.livechat`)"
                        :key="`footer-col2-link-${index}`"
                        :aria-label="`footer-col2-link-${index}.arialabel`"
                        :href="t(`footer.col_2.link_${index}.link`) || '#'")
                        icon(v-if="t(`footer.col_2.link_${index}.icon`)" :icon="t(`footer.col_2.link_${index}.icon`)" size="xl")

            .col-12.col-lg-5
                .bg-primary-4.p-8.border-radius-xl
                    .row
                        .col-12.col-md-6
                            label(v-if="t('footer.col_3.col_1.title')") {{ t('footer.col_3.col_1.title') }}
                            .d-flex.flex-column
                                a.link-gray(
                                    v-for="index in [1,2,3,4,5]"
                                    :key="`footer-col3-col1-link-${index}`"
                                    v-if="t([`footer.col_3.col_1.link_${index}.link`, `footer.col_3.col_1.link_${index}.label`])"
                                    :href="t(`footer.col_3.col_1.link_${index}.link`)")
                                    template(v-if="t(`footer.col_3.col_1.link_${index}.label`)") {{t(`footer.col_3.col_1.link_${index}.label`)}}
                        .col-12.col-md-6
                            label(v-if="t('footer.col_3.col_2.title')") {{ t('footer.col_3.col_2.title') }}
                            .d-flex.flex-column
                                a.link-gray(
                                    v-for="index in [1,2,3]"
                                    :key="`footer-col3-2-link-${index}`"
                                    v-if="t([`footer.col_3.col_2.link_${index}.link`, `footer.col_3.col_2.link_${index}.label`])"
                                    :href="t(`footer.col_3.col_2.link_${index}.link`)")
                                    template(v-if="t(`footer.col_3.col_2.link_${index}.label`)") {{t(`footer.col_3.col_2.link_${index}.label`)}}

            .col-12.d-flex.flex-wrap.flex-column.flex-md-row.align-items-center.justify-content-center.justify-content-xl-between.mt-5
                .d-flex.flex-wrap.justify-content-center.my-5(
                    v-for="blockIndex in [1,2,3]"
                    :key="`footer-bottom-block-${blockIndex}`")
                    a.link-gray.mr-3.text-nowrap(
                        v-for="index in [1,2,3,4,5]"
                        :key="`footer-bottom-block-${blockIndex}-${index}`"
                        v-if="t([`footer.bottom.block_${blockIndex}.link_${index}.link`])"
                        :class="{'link-icon': t(`footer.bottom.block_${blockIndex}.link_${index}.icon`)}"
                        :href="t(`footer.bottom.block_${blockIndex}.link_${index}.link`)"
                        :aria-label="t(`footer.bottom.block_${blockIndex}.link_${index}.arialabel`)")
                        template(v-if="t(`footer.bottom.block_${blockIndex}.link_${index}.label`)") {{t(`footer.bottom.block_${blockIndex}.link_${index}.label`)}}
                        icon(v-if="t(`footer.bottom.block_${blockIndex}.link_${index}.icon`)" :icon="t(`footer.bottom.block_${blockIndex}.link_${index}.icon`)"  size="2xl")
                        img.image(v-if="t(`footer.bottom.block_${blockIndex}.link_${index}.img`)"  v-lazy="`/images/${t(`footer.bottom.block_${blockIndex}.link_${index}.img`)}`" :alt="`footerLinkImage-${t(`footer.bottom.block_${blockIndex}.link_${index}.arialabel`) || t(`footer.bottom.block_${blockIndex}.link_${index}.img` || index)}`")
                    span.text-nowrap.text-73(v-if="t([`footer.bottom.block_${blockIndex}.text`])") {{t(`footer.bottom.block_${blockIndex}.text`)}}
</template>
<style>
.livechat {
    cursor: pointer;
}
</style>
